import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthDataService } from '../services/data-access/auth-data.service';

export const authGuard: CanActivateFn = () => {
  const authDataService = inject(AuthDataService);
  const router = inject(Router);

  if (authDataService.isLoggedIn()) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};
